import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import TourTicketDetail from './TourTicketDetail';
import action from "../../../../../actions";
import * as tourTicketActions from './../../../../../actions/tourTicketAction';

const mapStateToProps = state => {
    return {
        file: state.uploadReducer,
        tourTickets: state.tourTicketReducer,
        property: state.propertyReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onUploadFile: (filters) => dispatch(action.uploadAction(filters)),
        onCreateTourTicket: (params) => dispatch(tourTicketActions.createTourTicketAction(params)),
        onUpdateTourTicket: (id) => dispatch(tourTicketActions.updateTourTicketAction(id)),
        onGetUpdate: (id) => dispatch(tourTicketActions.getUpdateTourTicketAction(id)),
        createTourTicketTranslate: (tourTicket, language) => dispatch(tourTicketActions.createTourTicketTranslate(tourTicket, language)),
        updateTourTicketTranslate: (tourTicket, language) => dispatch(tourTicketActions.updateTourTicketTranslate(tourTicket, language)),
        deleteTourTicketTranslate: (tourTicket, refreshParams) => dispatch(tourTicketActions.deleteTourTicketTranslate(tourTicket, refreshParams)),
        onListAllProperties: () => dispatch(action.dataAllPropertyAction())
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(TourTicketDetail));
